/**
 * Adds a logout link to the shopify-account dropdown menu (next to Orders / Profile).
 * Shopify's account component does not include sign-out by default.
 */
(function () {
  const LOGOUT_ATTR = 'data-mega-smart-logout';

  function walkShadowRoots(root, callback) {
    callback(root);
    root.querySelectorAll('*').forEach((element) => {
      if (element.shadowRoot) walkShadowRoots(element.shadowRoot, callback);
    });
  }

  function findAccountMenu(root) {
    const menuLinks = [...root.querySelectorAll('a[href]')].filter((link) => {
      const href = link.getAttribute('href') || '';
      return (
        href.includes('/account') ||
        href.includes('/orders') ||
        href.includes('/profile') ||
        href.includes('shopify.com')
      );
    });

    if (menuLinks.length === 0) return null;

    const templateLink = menuLinks[menuLinks.length - 1];
    const listParent = templateLink.closest('ul, ol, nav, [role="menu"], [role="list"]');

    return { templateLink, listParent: listParent || templateLink.parentElement };
  }

  function isSignedIn(root) {
    if (root.querySelector('[part*="signed-in"], [class*="signed-in"], [data-signed-in="true"]')) {
      return true;
    }

    const emailInput = root.querySelector('input[type="email"]');
    if (emailInput) return false;

    return true;
  }

  function injectLogout(accountElement) {
    const logoutUrl = accountElement.dataset.logoutUrl;
    const logoutLabel = accountElement.dataset.logoutLabel || 'Wyloguj';

    if (!logoutUrl || !accountElement.shadowRoot) return;

    let menu = null;

    walkShadowRoots(accountElement.shadowRoot, (root) => {
      if (menu) return;
      menu = findAccountMenu(root);
    });

    if (!menu?.listParent || !menu.templateLink) return;
    if (menu.listParent.querySelector(`[${LOGOUT_ATTR}]`)) return;
    if (!isSignedIn(accountElement.shadowRoot)) return;

    const logoutItem = menu.templateLink.closest('li') || menu.templateLink;
    const logoutLink = menu.templateLink.cloneNode(true);

    logoutLink.setAttribute('href', logoutUrl);
    logoutLink.setAttribute(LOGOUT_ATTR, 'true');
    logoutLink.textContent = logoutLabel;

    if (logoutItem.tagName === 'LI') {
      const listItem = logoutItem.cloneNode(false);
      listItem.appendChild(logoutLink);
      menu.listParent.appendChild(listItem);
      return;
    }

    menu.listParent.appendChild(logoutLink);
  }

  function scheduleLogoutInjection(accountElement) {
    [0, 50, 150, 300].forEach((delay) => {
      window.setTimeout(() => injectLogout(accountElement), delay);
    });
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      scheduleLogoutInjection(event.target);
    },
    true
  );
})();
